import { setUsage } from "rtk-slice"

import { doc, getDoc, setDoc } from "firebase/firestore"

import { db } from "./firebaseConfig"

/**
 *
 * @param {object} user user object of the auth reducer
 * @param {hook} dispatch to access the redux dispatch function
 * @returns setCart(), setLSCart(), setLSTotalAmount()
 *
 * @function to run one time on login or @refresh depends on [user !== null],
 * it checks first if the cart field in doc() is not empty, then if so, it set @local cart state with
 * the cart field, set an encryptd @localStorage with the value of fields [cart, cartTotalAmount],
 * if there's no doc() at all, it resets the @local cart state with dispatch clearCart().
 */

export const getUsageFromFirebase = async ({ dispatch }) => {
  const foldersRef = doc(db, "folders", "statistics")
  const foldersSnap = await getDoc(foldersRef)
  const snippetsRef = doc(db, "snippets", "statistics")
  const snippetsSnap = await getDoc(snippetsRef)
  const screenshotsRef = doc(db, "screenshots", "statistics")
  const screenshotsSnap = await getDoc(screenshotsRef)

  if (foldersSnap.data()) {
    return dispatch(
      setUsage({
        foldersQty: foldersSnap.data().qty,
        snippetsQty: snippetsSnap.data().qty,
        screenshotsQty: screenshotsSnap.data().qty,
      })
    )
  } else {
    return false
  }
}

export const setUsageToFirebase = async ({
  document,
  value,
  dispatch,
}) => {
  if (document) {
    const usageRef = doc(db, document, "statistics")
    getUsageFromFirebase({ dispatch })

    // const usageSnap = await getDoc(usageRef)
    return setDoc(usageRef, {
      qty: value,
    })
  }
}
